import React, { useEffect, useCallback, useState} from 'react';
import {trim} from "utils/trim.js";
import {connect} from 'react-redux';
import './bank.scss';

const ZSampleBank = ({sampleBank, sampleDragging, _lastSampleSent, _samples}) => { 
    let [samples, setSamples] = useState(sampleBank.samples);
    let [lastSampleSent, setLastSampleSent] = useState(sampleBank.lastSampleSent);

    useEffect(() => {
        if (_samples) {
            setSamples(_samples);
        }
    }, [_samples, setSamples]);

    useEffect(() => {
        setLastSampleSent(_lastSampleSent);
    }, [_lastSampleSent, setLastSampleSent]);

    const onDrop = useCallback((e) => {
        e.stopPropagation();
        if (sampleDragging) {
            sampleBank.addSample(sampleDragging);
            setSamples([... sampleBank.samples]);
        }
    }, [sampleBank, sampleDragging, setSamples]);

    const deleteSample = useCallback((s) => {
        sampleBank.deleteSample(s);
        setSamples([... sampleBank.samples]);
    }, [sampleBank, setSamples]);

    return (
        <div onDrop={onDrop} className="sample-bank">
          <div className="samples">
            {samples &&
             samples.map(x =>
                 <div
                   onClick={() => {
                       sampleBank.sendSample(x);
                       setLastSampleSent(x);
                   }}
                   className={x === lastSampleSent ? "current sample-option" : "sample-option"}>
                   <div className="sample-name">{trim(x.name)}</div>
                   {x.tags.map(x => <div className="sample-tag">{trim(x)}</div>)}
                   <div onClick={() => deleteSample(x)} className="delete-btn">x</div>
                 </div>)}
          </div>
          {(!samples || samples.length === 0) &&
           <div  className="drop-here">
             <span className="drop-text">
               Drop Samples Here
             </span>
           </div>}
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
      _samples: props.sampleBank && props.sampleBank.samples,
      sampleDragging: state.selector.sampleDragging,
      _lastSampleSent: props.sampleBank && props.sampleBank.lastSampleSent
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ZSampleBank);
